import { VBtn } from 'vuetify/lib/components/VBtn';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VBtn,_vm._b({attrs:{"depressed":""},on:{"click":function($event){_vm.$emit('input', _vm.getSlugify(_vm.value))}}},'v-btn',_vm.$attrs,false),[_vm._v(" "+_vm._s(_vm.$t('Generate'))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }